import _ from 'lodash';
import { BidRegion } from 'src/const/state/bid-region';
import request from 'src/utils/request';
import apis from 'src/const/apis';

export const cityOptions = BidRegion;

export const fetchAreasData = async (param) => {
  let areaData;
  try {
    const areaRes = await request.get(apis.areasList, param);
    areaData = areaRes?.data?.areas || [];
  } catch (e) {
    areaData = [];
  }

  return areaData;
};


export const regionI18nKey = (id = '') => `region_${id.toUpperCase()}`;

/**
 * 记录每个国家在CountrySetOptions中的路径,最终形成一个映射
 * 如 US的路径为 '0'
 *   US+下面的BM路径为： '19.children.0'，
 * 此时映射为
 * {
 *  'US': '0',
 *  'BM': '19.children.0',
 * }
 */
export function getPathBidMap(map, obj, pathPrefix, intoChildren = true) {
  Object.keys(obj).forEach((key) => {
    const curObj = obj[key];
    // eslint-disable-next-line
    const curPath = (pathPrefix ? `${pathPrefix}.` : '') + key; // 若有前缀，则以点号连接
    if (!intoChildren && curObj.code) {
      map[curObj.code] = curPath; // 截取国家
    } else {
      map[curObj.id] = curPath;
    }
    // 如果有children属性，则递归进去
    if (intoChildren && curObj.children && curObj.children.length) {
      getPathBidMap(map, curObj.children, `${curPath}.children`);
    }
  });
}

// all国家两位码列表
export const createRegionCodeList = (options = BidRegion) => {
  const codeList = [];
  options.forEach((v) => {
    codeList.push(`${v.code}`);
  });
  return codeList;
};
export const createCountryMap = () => {
  const rlt = {};
  cityOptions.forEach((v) => {
    rlt[`${v.code}`] = v.name;
  });
  return rlt;
};
//  国家code获取id
export const CountryCode2IdMap = () => {
  const rlt = {};
  cityOptions.forEach((v) => {
    rlt[`${v.code}`] = v.id;
  });
  return rlt;
};

// 国家id获取code
export const CountryId2CodeMap = (countryOptions) => {
  const rlt = {};
  countryOptions.forEach((v) => {
    rlt[v.id] = `${v.code}`;
  });
  return rlt;
};

/**
 * 根据国家两位码列表，从options获取对应的子集
 *
 * @author liubin.frontend
 * @export
 * @param {*} countryCodes
 * @param {{id:string,name:string,children?: any[]}[]} options 国家城市对应集合
 * @returns
 */
export function filterInventoryCityOptions(countryCodes = [], options = []) {
  const regionOptions = [...options];

  const result = new Map();
  const countryBidPathMap = {};
  getPathBidMap(countryBidPathMap, regionOptions, '', false);

  for (const code of countryCodes) {
    const path = countryBidPathMap[code];

    if (path) {
      result.set(code, _.get(regionOptions, path));
    }
  }
  return [...result.values()];
}

// 把三级 cityOption 打平为一级数组
export const cityOptions2Array = (cityOptions = {}) => {
  const result = [];
  function push2Result(arr) {
    for (let i = 0; i < arr.length; i++) {
      const {
        i18n_key,
        id,
        name,
        translation,
        children = [],
        isDma,
        code = '',
      } = arr[i];
      result.push({
        i18n_key, id, name, translation, isDma, code,
      });
      if (children && children.length) {
        push2Result(children);
      }
    }
  }
  push2Result(cityOptions);
  return result;
};
